import React from 'react';
import BaseEVerifyUsersMFA from './BaseEVerifyUsersMFA';
import EnrollmentContent from '../../utils/EnrollmentContent';

const ChildEverifyUsersMFA = (): JSX.Element => {
  return <BaseEVerifyUsersMFA primaryText={EnrollmentContent.everifyUsersPrimaryTextMFA} />;
};

export default ChildEverifyUsersMFA;
